import React, { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
/** Styles Import */
import "./Style.css";
/** Services Import */
import Global from "../../Services/Common/Global";
import Commons from "../../Services/Common/Common";
import IndexedDb from "../../Services/IndexedDb/IndexedDb";
import Swal from "../../Components/SweetAlert2";
import TranslationService from "../../Services/Translation/TranslationService";
/** Components Import */
import Loading from "../../Components/Loading";
import { Card } from "react-bootstrap";
import AutoTranslate from "../../Components/AutoTranslate";

function SelectedSite() {
  const navigate = useNavigate();
  const location = useLocation();
  const [loading, setLoading] = useState(false);
  const [userInfo, setUserInfo] = useState(null);
  const [myDataList, setMyDataList] = useState([]);
  const language = useSelector((state) => state.localStorage.language);
  const authorization = useSelector((state) => state.localStorage.authorization);
  const [wording, setWording] = useState({
    placeholder1: "사업장 검색",
  });

  useEffect(() => {
    console.log("location", location.state);
    Init();
  }, []);

  useEffect(() => {
    if (!authorization.auth) {
      navigate("/");
    }
  }, [authorization.auth]);

  const Init = async () => {
    try {
      let userData = null;
      const _userData = await IndexedDb.GetUserInfo();
      userData = _userData;
      console.log("userData", userData);
      setUserInfo(userData);
      await Search();
      const _placeholder1 = await TranslationService.translateText(wording.placeholder1, language.lang);
      setWording({ ...wording, placeholder1: _placeholder1 });
    } finally {
      setLoading(false);
    }
  };

  const Search = async () => {
    try {
      const response = await Commons.Axios("get", Global.base.useUrl + Global.urls.Common.GetBizSite);
      console.log("Search2 response: ", response.data);
      if (response.status === 200) {
        if (response.data === "데이터가 없습니다.") {
          throw new Error("데이터가 없습니다.");
        } else {
          setMyDataList(response.data);
        }
      } else {
        throw new Error(JSON.stringify(response.data));
      }
    } catch (e) {
      console.log("Search2 Error: ", e);
    } finally {
    }
  };

  return (
    <div className='wrapper'>
      {loading && <Loading />}
      <div className='flex-column-center'>
        <Card className='w-100 modern-main-card'>
          <Card.Header className='modern-main-card-header pt-3'>
            <Card.Title
              style={{
                fontSize: "1.5rem",
                fontWeight: "700",
                color: "#2c3e50",
                marginBottom: "0.5rem",
              }}
            >
              <AutoTranslate targetLanguage={language.lang}>내 사업장 목록</AutoTranslate>
            </Card.Title>
            <Card.Text
              style={{
                fontSize: "1rem",
                color: "#6c757d",
                fontWeight: "500",
              }}
            >
              <AutoTranslate targetLanguage={language.lang}>카드를 누르면 다음 페이지로 이동합니다.</AutoTranslate>
            </Card.Text>
          </Card.Header>
          <Card.Body className={`${Commons.IsMobile() ? "" : "flex-start-center flex-wrap gap-4"} modern-main-card-body`}>
            {myDataList.length === 0 && (
              <div
                className='flex-column-center-center w-100 mb-5 modern-empty-state'
                style={{
                  fontSize: "1.2rem",
                  fontWeight: "600",
                  color: "#6c757d",
                  padding: "3rem 1rem",
                  cursor: "pointer",
                }}
              >
                <div
                  style={{
                    background: "rgba(108, 117, 125, 0.1)",
                    borderRadius: "50%",
                    width: "80px",
                    height: "80px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    marginBottom: "1rem",
                  }}
                >
                  <span style={{ fontSize: "2rem", color: "#6c757d" }}>🏢</span>
                </div>
                <p style={{ margin: "0 0 0.5rem 0" }}>
                  <AutoTranslate targetLanguage={language.lang}>신청한 사업장이 없습니다.</AutoTranslate>
                </p>
                <p style={{ margin: 0, fontSize: "1rem", color: "#adb5bd" }}>
                  <AutoTranslate targetLanguage={language.lang}>관리자 웹에서 현장을 등록하세요.</AutoTranslate>
                </p>
              </div>
            )}
            {myDataList.map((item, index) => {
              return (
                <Card key={index} className='cursor-pointer modern-company-card'>
                  <Card.Body
                    className={`${Commons.IsMobile() ? "flex-between-center" : "flex-start-center gap-3"} modern-company-card-body`}
                    onClick={() => {
                      Swal.warning("준비중입니다.");
                      // navigate("/composed-education", { state: { company: { companyName: userInfo.companyName, companyCode: userInfo.companyCode }, sites: item } });
                    }}
                  >
                    <span className='modern-company-text'>
                      <AutoTranslate targetLanguage={language.lang}>{item.siteName}</AutoTranslate>
                    </span>
                    <div className='modern-company-arrow'>
                      <span style={{ fontSize: "1rem", color: "#adb5bd" }}>→</span>
                    </div>
                  </Card.Body>
                </Card>
              );
            })}
          </Card.Body>
        </Card>
      </div>
    </div>
  );
}

export default SelectedSite;
